import React from "react";
import { TextField } from "@mui/material";

const CustomTextInput = ({
  label,
  placeholder,
  onChangeText,
  error,
  value,
  maxlength,
  autoComplete = "off",
  inputMode,
  type = "text",
}) => (
  <div style={{ width: "100%" }}>
    <TextField
      placeholder={placeholder}
      helperText={error || undefined}
      error={Boolean(error)}
      label={label}
      value={value}
      inputProps={{
        maxLength: maxlength,
        autoComplete,
        inputMode,
      }}
      autoComplete={autoComplete}
      type={type}
      onChange={(e) => onChangeText(e.target.value)}
      sx={{
        width: "100%",
        fontSize: 14,
        mb: 0.5,
        "& .MuiOutlinedInput-root": {
          "&.Mui-focused, &:focus-visible": {
            boxShadow: "none",
          },
        },
        "& .MuiOutlinedInput-input": {
          "&:focus, &:focus-visible": {
            boxShadow: "none",
            outline: "none",
          },
        },
        "& .MuiFormHelperText-root": {
          minHeight: error ? "1.25em" : 0,
          mt: error ? 0.25 : 0,
        },
      }}
      FormHelperTextProps={{
        sx: { mx: 0 },
      }}
    />
  </div>
);

export default CustomTextInput;
